import React from 'react';
import { Redirect } from 'react-router-dom';

const NotFound = (props) => {
    if (!props.loggedIn)
        return <Redirect to="/login" />;

    return (
    <div>
       <h2><code>Pagina no encontrada</code></h2>
    </div>    
    );
}

export default NotFound;


// WEBPACK FOOTER //
// ./Portico/App/Screens/Errores/NotFound.jsx